import React, { memo } from "react";
import exam from "../../assets/images/coming-soon/exam.svg";
import spelling from "../../assets/images/coming-soon/spelling.svg";
import holdChild from "../../assets/images/coming-soon/hold-child.svg";
import food from "../../assets/images/coming-soon/food.svg";
import aircon from "../../assets/images/coming-soon/aircon.svg";
import guidance from "../../assets/images/coming-soon/guidance.svg";
import teacherStudent from "../../assets/images/coming-soon/teacher-student.svg";

const surveyContent = [
  {
    _id: 1,
    icon: guidance,
    descriptions: `Homework supervision & guidance`,
    bgColor: "#F8C0B9",
    delayAnimation: "0",
  },
  {
    _id: 2,
    icon: spelling,
    descriptions: `Daily testing of spelling & 听写 (TingXie)`,
    bgColor: "#BBEBD2",
    delayAnimation: "0",
  },
  {
    _id: 3,
    icon: exam,
    descriptions: `Practice test papers from top schools`,
    bgColor: "#B0DAEE",
    delayAnimation: "0",
  },
  // {
  //   _id: 4,
  //   icon: teacherStudent,
  //   descriptions: `Low student-teacher ratio`,
  //   bgColor: "#F8C537",
  //   delayAnimation: "0",
  // },
  {
    _id: 5,
    icon: food,
    descriptions: `Home-cooked food prepared in-house`,
    bgColor: "#F2F5D0",
    delayAnimation: "0",
  },
  {
    _id: 6,
    icon: aircon,
    descriptions: `Spacious and fully air-conditioned environment`,
    bgColor: "#F1FADE",
    delayAnimation: "0",
  },
  // {
  //   _id: 7,
  //   icon: holdChild,
  //   descriptions: `Free fetching service from Evergreen Primary School`,
  //   bgColor: "#DDFDFE",
  //   delayAnimation: "0",
  // }
];

const SurveyItem = memo(({ survey }) => (
  <div
    className="col-lg-3 col-md-6"
    data-aos="fade-up"
    data-aos-delay={survey.delayAnimation}
    key={survey._id}
  >
    <div className="block-style-thirtyFive text-center mt-30">
      <div
        className="icon d-flex align-items-center justify-content-center"
        style={{ background: survey.bgColor }}
      >
        <img src={survey.icon} alt="survey icon" />
      </div>
      <p>{survey.descriptions}</p>
    </div>
  </div>
));

const HowWorks = () => {
  return (
    <>
      {surveyContent.map((survey) => (
        <SurveyItem key={survey._id} survey={survey} />
      ))}
    </>
  );
};

export default memo(HowWorks);